var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loader_svg__py1yflspsa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36a17.9 17.9 0 01-7.007-1.413 17.94 17.94 0 01-5.72-3.86 17.94 17.94 0 01-3.86-5.72A17.885 17.885 0 010 18a1.265 1.265 0 112.531 0 15.445 15.445 0 004.532 10.94 15.39 15.39 0 004.918 3.316A15.381 15.381 0 0018 33.469a15.444 15.444 0 0010.94-4.532 15.39 15.39 0 003.316-4.918A15.381 15.381 0 0033.469 18a15.35 15.35 0 00-1.217-6.022 15.484 15.484 0 00-3.315-4.919 15.388 15.388 0 00-4.918-3.315A15.38 15.38 0 0018 2.531 1.265 1.265 0 1118 0a17.9 17.9 0 017.007 1.413 17.94 17.94 0 015.72 3.86 17.968 17.968 0 013.856 5.72A17.885 17.885 0 0135.996 18c0 2.43-.474 4.788-1.413 7.007a17.873 17.873 0 01-3.856 5.72A17.968 17.968 0 0118 36z",
    fill: "#52CA46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loader_svg__py1yflspsa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}
export default SvgLoader;